import { render, staticRenderFns } from "./offerPlatform.vue?vue&type=template&id=26d33dea"
import script from "./offerPlatform.vue?vue&type=script&lang=js"
export * from "./offerPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports